@for (notification of notifications; track notification) {
  <div class="display-flex p-3 notification-content">
    <div class="pr-2 display-flex image-container">
      <img class="notification-icon" [alt]="notification?.messageType"
        src="/assets/images/notifications/notifications-{{notification?.messageType}}.svg">
      </div>
      <div
        class="col-10">
        @if (notification?.messageInfo; as notificationText) {
          <app-notification-info
            [notificationText]="notificationText"
            [language]="notification.language">
          </app-notification-info>
        }
      </div>
      <div class="cursor-pointer my-auto close-notification"
        (click)="removeFromNotifications(notification?.notificationUUID); $event.stopPropagation()"
        >
        ×
      </div>
    </div>
  }
  @if (notifications?.length) {
    <div
      (click)="clearAllNotifications()"
      class="display-inline-block mr-3 pb-2 float-right text-color-grey font-weight-semibold cursor-pointer clear-all-notifications"
      ><ng-container i18n="@@app.remove_all">Remove all</ng-container></div>
    }
